// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { ApproverUserDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
export type ApprovalSubject_ChangeRequestFragment = { __typename?: 'ChangeRequest', id: string, name: string, rationale: string, estimateBudgetImpactInCents?: number | null | undefined, markupBasisPoints?: number | null | undefined, estimatedBuyerOutOfPocketInCents?: number | null | undefined, estimatedRetailPriceInCents?: number | null | undefined, estimateMarginImpactBasisPoints?: number | null | undefined, blueprintUrl: { __typename?: 'Url', path: string }, scopes: Array<{ __typename?: 'ChangeRequestScope', id: string, target: { __typename?: 'StandaloneProject', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Region', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Development', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Market', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Community', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Subdivision', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Lot', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Structure', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'Unit', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } } }>, predictedApprovers: Array<{ __typename?: 'Client', id: string, name: string } | { __typename?: 'InternalUser', id: string, avatar: string, name: string } | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }> };

export const ApprovalSubject_ChangeRequestFragmentDoc = gql`
    fragment ApprovalSubject_ChangeRequest on ChangeRequest {
  id
  name
  rationale
  blueprintUrl {
    path
  }
  scopes {
    id
    target {
      ...Named
      ... on HasBlueprintUrl {
        id
        blueprintUrl {
          path
        }
      }
    }
  }
  estimateBudgetImpactInCents
  markupBasisPoints
  estimatedBuyerOutOfPocketInCents
  estimatedRetailPriceInCents
  estimateMarginImpactBasisPoints
  predictedApprovers {
    ...ApproverUserDetail
  }
}
    ${NamedFragmentDoc}
${ApproverUserDetailFragmentDoc}`;